import SearchIcon from '@mui/icons-material/Search';
import { FormControl, InputAdornment, OutlinedInput } from '@mui/material';
import React from 'react';

type Props = {
	onChange: (
		e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
	) => void;
};

const SearchField = ({ onChange }: Props) => (
	<FormControl sx={{ m: 1, mb: 0.5, width: '25ch' }} variant="outlined">
		<OutlinedInput
			size="small"
			type="search"
			onChange={onChange}
			placeholder={intl.tr('actions.search')}
			startAdornment={
				<InputAdornment position="start">
					<SearchIcon color="disabled" />
				</InputAdornment>
			}
		/>
	</FormControl>
);

export default SearchField;
